import api from "../utils/axiosInstance";

const BASE_URL = "/api/products";

// 1. Fetch all products
export const getAllProducts = async () => {
  const response = await api.get(BASE_URL);
  return response.data;
};

// 2. Fetch single product
export const getProductById = async (id) => {
  const response = await api.get(`${BASE_URL}/${id}`);
  return response.data;
};


// 3. Fetch products by collection ID
//export const getProductsByCollection = async (collectionId) => {
//  const response = await api.get(`${BASE_URL}/collection/${collectionId}`);
//  return response.data;
//};

// 4. Add product (Admin)
export const addProduct = async (product) => {
  const response = await api.post(BASE_URL, product);
  return response.data;
};
//export const getProductsByCollection = async (collectionId) => {
//  const response = await api.get(`/api/products/collection/id/${collectionId}`);
//  return response.data;
//};
export const getProductsByCollection = async (id) => {
  const res = await api.get(`/api/products/collection/id/${id}`);
  return res.data;
};
export const filterProducts = async (id, filters) => {

  const res = await api.get(`/api/products/collection/${id}/filter`, {
    params: filters
  });

  return res.data;
};
// 5. SEARCH PRODUCTS
export const searchProducts = async () => {

  const response = await api.get(BASE_URL);

  return response.data || [];

};

export const getProductsByCollectionSlug =
  async (slug) => {

  const res =
    await api.get(
      `/api/products/collection/slug/${slug}`
    );

  return res.data;

};